import { cn } from '@/lib/utils'

/**
 * The small uppercase heading a sidebar section starts with.
 *
 * The journeys and the device list both show journey walkers, and without a
 * name on each block they read as two views of one thing — which is what the
 * first round of feedback said they looked like. Styled like the "Connect your
 * app" heading, so the sidebar has one kind of heading, not two.
 */
export function SectionTitle({
  children,
  aside,
  className,
}: {
  children: React.ReactNode
  /** Right-aligned, muted: a count, a spinner. */
  aside?: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'text-muted-foreground flex items-center gap-1.5 text-[10px] font-medium uppercase tracking-wide',
        className,
      )}
    >
      <h2 className="min-w-0 flex-1 truncate">{children}</h2>
      {aside}
    </div>
  )
}
